<fl-view-settings
  [definition]="definition()"
  (apply)="onApply()"
  (closeDialog)="service.close()"
  (resetSettings)="service.reset($event)"
  (settingChanged)="onChange($event)"
/>
